import { Routes } from '@angular/router';

import { demoOrRedirectIfAuthenticatedGuard } from '../../../core/demo/demo-session.guard';
import { LoginComponent } from '../login.component';

export const loginRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [demoOrRedirectIfAuthenticatedGuard],
  },
];
